// (function () {

//   function updatePurchaseOptions() {

//     var planCards = document.querySelectorAll('.plan_card');

//     if (!planCards.length) return;


//     planCards.forEach(function (planCard) {

//       var groups = planCard.querySelectorAll(
//         '.subscription_group'
//       );

//       if (!groups.length) return;


//       /* ==========================================
//          UPDATE ACTIVE GROUP
//       ========================================== */

//       groups.forEach(function (group) {

//         var radios = group.querySelectorAll(
//           'input[type="radio"]'
//         );

//         var isSelected = false;

//         radios.forEach(function (radio) {

//           if (radio.checked) {
//             isSelected = true;
//           }

//         });

//         if (isSelected) {
//           group.classList.add('active');
//         } else {
//           group.classList.remove('active');
//         }

//       });


//       /* ==========================================
//          UPDATE TEXT
//       ========================================== */

//       groups.forEach(function (group) {

//         var subscriptionRadio = group.querySelector(
//           'input[data-radio-type="selling_plan"]'
//         );

//         var oneTimeRadio = group.querySelector(
//           'input[data-radio-type="one_time_purchase"]'
//         );


//         /* ==========================================
//            SUBSCRIBE & SAVE 10%
//         ========================================== */

//         if (subscriptionRadio) {

//           var wrapper = group.querySelector(
//             ':scope > .title_and_price_wrapper'
//           );

//           if (wrapper) {

//             var span = wrapper.querySelector('span');

//             if (span) {
//               span.textContent = 'SUBSCRIBE & SAVE 10%';
//             }

//           }

//         }


//         /* ==========================================
//            BUY ONCE
//         ========================================== */

//         if (oneTimeRadio) {

//           var oneTimeText = group.querySelector(
//             '.one_time_purchase_option_app_block span'
//           );

//           if (oneTimeText) {
//             oneTimeText.textContent = 'BUY ONCE';
//           }

//         }

//       });

//     });

//   }


//   /* ==========================================
//      INITIAL
//   ========================================== */

//   updatePurchaseOptions();


//   /* ==========================================
//      DOM READY
//   ========================================== */

//   if (document.readyState === 'loading') {

//     document.addEventListener(
//       'DOMContentLoaded',
//       updatePurchaseOptions
//     );

//   }


//   /* ==========================================
//      WINDOW LOAD
//   ========================================== */

//   window.addEventListener('load', function () {

//     updatePurchaseOptions();

//     setTimeout(updatePurchaseOptions, 100);
//     setTimeout(updatePurchaseOptions, 300);
//     setTimeout(updatePurchaseOptions, 500);
//     setTimeout(updatePurchaseOptions, 1000);
//     setTimeout(updatePurchaseOptions, 2000);

//   });


//   /* ==========================================
//      RADIO CHANGE
//   ========================================== */

//   document.addEventListener('change', function (event) {

//     if (
//       event.target.matches(
//         '.plan_card input[type="radio"]'
//       )
//     ) {

//       setTimeout(updatePurchaseOptions, 0);
//       setTimeout(updatePurchaseOptions, 100);
//       setTimeout(updatePurchaseOptions, 300);

//     }

//   });


//   /* ==========================================
//      CLICK
//   ========================================== */

//   document.addEventListener('click', function (event) {

//     if (
//       event.target.closest(
//         '.plan_card .subscription_group'
//       )
//     ) {

//       setTimeout(updatePurchaseOptions, 50);
//       setTimeout(updatePurchaseOptions, 200);
//       setTimeout(updatePurchaseOptions, 500);

//     }

//   });


//   /* ==========================================
//      RESIZE
//   ========================================== */

//   window.addEventListener('resize', function () {

//     updatePurchaseOptions();

//   });


//   /* ==========================================
//      DYNAMIC SHOPIFY / SUBSCRIPTION APP CONTENT
//   ========================================== */

//   var observer = new MutationObserver(function () {

//     updatePurchaseOptions();

//   });


//   observer.observe(document.body, {

//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: [
//       'class',
//       'checked'
//     ]

//   });


// })();










// (function () {

//   'use strict';

//   /* =========================================================
//      SETTINGS
//   ========================================================= */

//   var SELECTORS = {
//     parent: '.product-new-pdp',
//     planCard: '.plan_card',
//     group: '.subscription_group',
//     radio: 'input[type="radio"]',
//     subscription: 'input[data-radio-type="selling_plan"]',
//     oneTime: 'input[data-radio-type="one_time_purchase"]'
//   };

//   var updateTimer = null;
//   var observerTimer = null;

//   /*
//    * Remember the user's purchase selection.
//    *
//    * IMPORTANT:
//    * This is only used when Shopify rebuilds the DOM after
//    * a variant change.
//    */
//   var selectedPurchaseType = null;


//   /* =========================================================
//      GET PURCHASE TYPE
//      ========================================================= */

//   function getPurchaseType(radio) {

//     if (!radio) return null;

//     var type = radio.getAttribute('data-radio-type');

//     if (type === 'selling_plan') {
//       return 'subscription';
//     }

//     if (type === 'one_time_purchase') {
//       return 'one_time';
//     }

//     return null;
//   }


//   /* =========================================================
//      FIND CURRENT SELECTED PURCHASE TYPE
//      ========================================================= */

//   function detectCurrentPurchaseType() {

//     var checkedRadio = document.querySelector(
//       SELECTORS.planCard + ' ' +
//       SELECTORS.group + ' ' +
//       SELECTORS.radio + ':checked'
//     );

//     if (!checkedRadio) return null;

//     return getPurchaseType(checkedRadio);
//   }


//   /* =========================================================
//      GET RADIO FOR PURCHASE TYPE
//      ========================================================= */

//   function getRadioForType(planCard, type) {

//     if (!planCard || !type) return null;

//     if (type === 'subscription') {

//       return planCard.querySelector(
//         SELECTORS.group + ' ' + SELECTORS.subscription
//       );

//     }

//     if (type === 'one_time') {

//       return planCard.querySelector(
//         SELECTORS.group + ' ' + SELECTORS.oneTime
//       );

//     }

//     return null;
//   }


//   /* =========================================================
//      UPDATE ACTIVE CLASS ONLY
//      FROM ACTUAL CHECKED RADIO
//      ========================================================= */

//   function updateActiveClasses(planCard) {

//     var groups = planCard.querySelectorAll(
//       SELECTORS.group
//     );

//     groups.forEach(function (group) {

//       var radio = group.querySelector(
//         SELECTORS.radio
//       );

//       if (radio && radio.checked) {
//         group.classList.add('active');
//       } else {
//         group.classList.remove('active');
//       }

//     });

//   }


//   /* =========================================================
//      UPDATE TEXT
//      ========================================================= */

//   function updateTexts(planCard) {

//     var groups = planCard.querySelectorAll(
//       SELECTORS.group
//     );

//     groups.forEach(function (group) {

//       /* -----------------------------------------
//          SUBSCRIBE & SAVE
//       ----------------------------------------- */

//       var subscriptionRadio = group.querySelector(
//         SELECTORS.subscription
//       );

//       if (subscriptionRadio) {

//         var subscriptionLabel =
//           subscriptionRadio.closest('label');

//         if (subscriptionLabel) {

//           var textSpan =
//             subscriptionLabel.querySelector(
//               '.title_and_price_wrapper > span'
//             );

//           if (textSpan) {
//             textSpan.textContent =
//               'SUBSCRIBE & SAVE 10%';
//           }

//         }

//       }


//       /* -----------------------------------------
//          BUY ONCE
//       ----------------------------------------- */

//       var oneTimeRadio = group.querySelector(
//         SELECTORS.oneTime
//       );

//       if (oneTimeRadio) {

//         var oneTimeText =
//           group.querySelector(
//             '.one_time_purchase_option_app_block span'
//           );

//         if (oneTimeText) {
//           oneTimeText.textContent = 'BUY ONCE';
//         }

//       }

//     });

//   }


//   /* =========================================================
//      SYNC PURCHASE OPTIONS
//      ========================================================= */

//   function updatePurchaseOptions() {

//     var planCards = document.querySelectorAll(
//       SELECTORS.planCard
//     );

//     if (!planCards.length) return;


//     /*
//      * First detect the REAL current checked radio.
//      *
//      * Never use .active for this.
//      */

//     var currentType = detectCurrentPurchaseType();

//     if (currentType) {
//       selectedPurchaseType = currentType;
//     }


//     planCards.forEach(function (planCard) {

//       var groups = planCard.querySelectorAll(
//         SELECTORS.group
//       );

//       if (!groups.length) return;


//       /*
//        * ------------------------------------------------------
//        * IMPORTANT:
//        *
//        * If Shopify rebuilt the purchase UI after changing
//        * variant and nothing is checked, restore the user's
//        * previous purchase type.
//        * ------------------------------------------------------
//        */

//       var checkedRadio = planCard.querySelector(
//         SELECTORS.group +
//         ' ' +
//         SELECTORS.radio +
//         ':checked'
//       );


//       if (!checkedRadio && selectedPurchaseType) {

//         var restoreRadio = getRadioForType(
//           planCard,
//           selectedPurchaseType
//         );

//         if (restoreRadio) {

//           /*
//            * Set property only.
//            *
//            * NO click()
//            * NO dispatchEvent()
//            * NO PointerEvent
//            */

//           restoreRadio.checked = true;

//           checkedRadio = restoreRadio;
//         }

//       }


//       /*
//        * ------------------------------------------------------
//        * If a radio is already selected, update memory.
//        * ------------------------------------------------------
//        */

//       if (checkedRadio) {

//         var type = getPurchaseType(
//           checkedRadio
//         );

//         if (type) {
//           selectedPurchaseType = type;
//         }

//       }


//       /*
//        * ------------------------------------------------------
//        * Update active classes based ONLY on checked radio.
//        * ------------------------------------------------------
//        */

//       updateActiveClasses(planCard);


//       /*
//        * ------------------------------------------------------
//        * Update text.
//        * ------------------------------------------------------
//        */

//       updateTexts(planCard);

//     });

//   }


//   /* =========================================================
//      SAFE UPDATE
//      ========================================================= */

//   function scheduleUpdate(delay) {

//     clearTimeout(updateTimer);

//     updateTimer = setTimeout(function () {

//       updatePurchaseOptions();

//     }, typeof delay === 'number' ? delay : 50);

//   }


//   /* =========================================================
//      RADIO CHANGE
//      ========================================================= */

//   document.addEventListener(
//     'change',
//     function (event) {

//       var target = event.target;

//       if (!target) return;

//       if (
//         target.matches(
//           SELECTORS.planCard +
//           ' ' +
//           SELECTORS.group +
//           ' ' +
//           SELECTORS.radio
//         )
//       ) {

//         /*
//          * User intentionally changed purchase type.
//          * Save it immediately.
//          */

//         var type = getPurchaseType(target);

//         if (type) {
//           selectedPurchaseType = type;
//         }

//         /*
//          * Give the subscription app time to finish
//          * its own change handler.
//          */

//         scheduleUpdate(50);

//         setTimeout(function () {
//           updatePurchaseOptions();
//         }, 200);

//         setTimeout(function () {
//           updatePurchaseOptions();
//         }, 500);

//       }

//     },
//     true
//   );


//   /* =========================================================
//      CLICK
//      ========================================================= */

//   document.addEventListener(
//     'click',
//     function (event) {

//       var target = event.target;

//       if (!target) return;


//       var group = target.closest(
//         SELECTORS.planCard +
//         ' ' +
//         SELECTORS.group
//       );

//       if (!group) return;


//       /*
//        * DO NOT manually click the radio.
//        *
//        * Let the subscription app handle the original
//        * browser click event.
//        */

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 100);

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 300);

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 600);

//     },
//     true
//   );


//   /* =========================================================
//      VARIANT CHANGE DETECTION
//      ========================================================= */

//   /*
//    * Shopify/product apps can change variant without
//    * changing the purchase radio immediately.
//    *
//    * We observe DOM changes but NEVER overwrite an existing
//    * checked radio.
//    */

//   function startObserver() {

//     if (!document.body) return;

//     var observer = new MutationObserver(
//       function (mutations) {

//         var relevantChange = false;

//         mutations.forEach(function (mutation) {

//           if (mutation.type === 'childList') {
//             relevantChange = true;
//           }

//           if (
//             mutation.type === 'attributes' &&
//             (
//               mutation.attributeName === 'checked' ||
//               mutation.attributeName === 'class'
//             )
//           ) {
//             relevantChange = true;
//           }

//         });

//         if (!relevantChange) return;

//         clearTimeout(observerTimer);

//         observerTimer = setTimeout(
//           function () {
//             updatePurchaseOptions();
//           },
//           150
//         );

//       }
//     );


//     observer.observe(
//       document.body,
//       {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: [
//           'checked',
//           'class'
//         ]
//       }
//     );

//   }


//   /* =========================================================
//      INITIAL LOAD
//      ========================================================= */

//   function init() {

//     /*
//      * Capture whatever Shopify initially selected.
//      */

//     var initialType =
//       detectCurrentPurchaseType();

//     if (initialType) {
//       selectedPurchaseType = initialType;
//     }


//     updatePurchaseOptions();

//     startObserver();


//     /*
//      * Shopify/subscription app delayed rendering.
//      */

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 100);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 300);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 600);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 1000);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 2000);

//   }


//   /* =========================================================
//      DOM READY
//      ========================================================= */

//   if (document.readyState === 'loading') {

//     document.addEventListener(
//       'DOMContentLoaded',
//       init
//     );

//   } else {

//     init();

//   }


//   /* =========================================================
//      WINDOW LOAD
//      ========================================================= */

//   window.addEventListener(
//     'load',
//     function () {
//       scheduleUpdate(100);
//     }
//   );

// })();


// (function () {

//   function updatePurchaseOptions() {

//     var planCards = document.querySelectorAll('.plan_card');

//     if (!planCards.length) return;


//     planCards.forEach(function (planCard) {

//       var groups = planCard.querySelectorAll(
//         '.subscription_group'
//       );

//       if (!groups.length) return;


//       /* ==========================================
//          UPDATE ACTIVE GROUP
//       ========================================== */

//       groups.forEach(function (group) {

//         var radios = group.querySelectorAll(
//           'input[type="radio"]'
//         );

//         var isSelected = false;

//         radios.forEach(function (radio) {

//           if (radio.checked) {
//             isSelected = true;
//           }

//         });

//         if (isSelected) {
//           group.classList.add('active');
//         } else {
//           group.classList.remove('active');
//         }

//       });


//       /* ==========================================
//          UPDATE TEXT
//       ========================================== */

//       groups.forEach(function (group) {

//         var subscriptionRadio = group.querySelector(
//           'input[data-radio-type="selling_plan"]'
//         );

//         var oneTimeRadio = group.querySelector(
//           'input[data-radio-type="one_time_purchase"]'
//         );


//         /* ==========================================
//            SUBSCRIBE & SAVE 10%
//         ========================================== */

//         if (subscriptionRadio) {

//           var wrapper = group.querySelector(
//             ':scope > .title_and_price_wrapper'
//           );

//           if (wrapper) {

//             var span = wrapper.querySelector('span');

//             if (span) {
//               span.textContent = 'SUBSCRIBE & SAVE 10%';
//             }

//           }

//         }


//         /* ==========================================
//            BUY ONCE
//         ========================================== */

//         if (oneTimeRadio) {

//           var oneTimeText = group.querySelector(
//             '.one_time_purchase_option_app_block span'
//           );

//           if (oneTimeText) {
//             oneTimeText.textContent = 'BUY ONCE';
//           }

//         }

//       });

//     });

//   }


//   /* ==========================================
//      INITIAL
//   ========================================== */

//   updatePurchaseOptions();


//   /* ==========================================
//      DOM READY
//   ========================================== */

//   if (document.readyState === 'loading') {

//     document.addEventListener(
//       'DOMContentLoaded',
//       updatePurchaseOptions
//     );

//   }


//   /* ==========================================
//      WINDOW LOAD
//   ========================================== */

//   window.addEventListener('load', function () {

//     updatePurchaseOptions();

//     setTimeout(updatePurchaseOptions, 100);
//     setTimeout(updatePurchaseOptions, 300);
//     setTimeout(updatePurchaseOptions, 500);
//     setTimeout(updatePurchaseOptions, 1000);
//     setTimeout(updatePurchaseOptions, 2000);

//   });


//   /* ==========================================
//      RADIO CHANGE
//   ========================================== */

//   document.addEventListener('change', function (event) {

//     if (
//       event.target.matches(
//         '.plan_card input[type="radio"]'
//       )
//     ) {

//       setTimeout(updatePurchaseOptions, 0);
//       setTimeout(updatePurchaseOptions, 100);
//       setTimeout(updatePurchaseOptions, 300);

//     }

//   });


//   /* ==========================================
//      CLICK
//   ========================================== */

//   document.addEventListener('click', function (event) {

//     if (
//       event.target.closest(
//         '.plan_card .subscription_group'
//       )
//     ) {

//       setTimeout(updatePurchaseOptions, 50);
//       setTimeout(updatePurchaseOptions, 200);
//       setTimeout(updatePurchaseOptions, 500);

//     }

//   });


//   /* ==========================================
//      RESIZE
//   ========================================== */

//   window.addEventListener('resize', function () {

//     updatePurchaseOptions();

//   });


//   /* ==========================================
//      DYNAMIC SHOPIFY / SUBSCRIPTION APP CONTENT
//   ========================================== */

//   var observer = new MutationObserver(function () {

//     updatePurchaseOptions();

//   });


//   observer.observe(document.body, {

//     childList: true,
//     subtree: true,
//     attributes: true,
//     attributeFilter: [
//       'class',
//       'checked'
//     ]

//   });


// })();










// (function () {

//   'use strict';

//   /* =========================================================
//      SETTINGS
//   ========================================================= */

//   var SELECTORS = {
//     parent: '.product-new-pdp',
//     planCard: '.plan_card',
//     group: '.subscription_group',
//     radio: 'input[type="radio"]',
//     subscription: 'input[data-radio-type="selling_plan"]',
//     oneTime: 'input[data-radio-type="one_time_purchase"]'
//   };

//   var updateTimer = null;
//   var observerTimer = null;

//   /*
//    * Remember the user's purchase selection.
//    *
//    * IMPORTANT:
//    * This is only used when Shopify rebuilds the DOM after
//    * a variant change.
//    */
//   var selectedPurchaseType = null;


//   /* =========================================================
//      GET PURCHASE TYPE
//      ========================================================= */

//   function getPurchaseType(radio) {

//     if (!radio) return null;

//     var type = radio.getAttribute('data-radio-type');

//     if (type === 'selling_plan') {
//       return 'subscription';
//     }

//     if (type === 'one_time_purchase') {
//       return 'one_time';
//     }

//     return null;
//   }


//   /* =========================================================
//      FIND CURRENT SELECTED PURCHASE TYPE
//      ========================================================= */

//   function detectCurrentPurchaseType() {

//     var checkedRadio = document.querySelector(
//       SELECTORS.planCard + ' ' +
//       SELECTORS.group + ' ' +
//       SELECTORS.radio + ':checked'
//     );

//     if (!checkedRadio) return null;

//     return getPurchaseType(checkedRadio);
//   }


//   /* =========================================================
//      GET RADIO FOR PURCHASE TYPE
//      ========================================================= */

//   function getRadioForType(planCard, type) {

//     if (!planCard || !type) return null;

//     if (type === 'subscription') {

//       return planCard.querySelector(
//         SELECTORS.group + ' ' + SELECTORS.subscription
//       );

//     }

//     if (type === 'one_time') {

//       return planCard.querySelector(
//         SELECTORS.group + ' ' + SELECTORS.oneTime
//       );

//     }

//     return null;
//   }


//   /* =========================================================
//      UPDATE ACTIVE CLASS ONLY
//      FROM ACTUAL CHECKED RADIO
//      ========================================================= */

//   function updateActiveClasses(planCard) {

//     var groups = planCard.querySelectorAll(
//       SELECTORS.group
//     );

//     groups.forEach(function (group) {

//       var radio = group.querySelector(
//         SELECTORS.radio
//       );

//       if (radio && radio.checked) {
//         group.classList.add('active');
//       } else {
//         group.classList.remove('active');
//       }

//     });

//   }


//   /* =========================================================
//      UPDATE TEXT
//      ========================================================= */

//   function updateTexts(planCard) {

//     var groups = planCard.querySelectorAll(
//       SELECTORS.group
//     );

//     groups.forEach(function (group) {

//       /* -----------------------------------------
//          SUBSCRIBE & SAVE
//       ----------------------------------------- */

//       var subscriptionRadio = group.querySelector(
//         SELECTORS.subscription
//       );

//       if (subscriptionRadio) {

//         var subscriptionLabel =
//           subscriptionRadio.closest('label');

//         if (subscriptionLabel) {

//           var textSpan =
//             subscriptionLabel.querySelector(
//               '.title_and_price_wrapper > span'
//             );

//           if (textSpan) {
//             textSpan.textContent =
//               'SUBSCRIBE & SAVE 10%';
//           }

//         }

//       }


//       /* -----------------------------------------
//          BUY ONCE
//       ----------------------------------------- */

//       var oneTimeRadio = group.querySelector(
//         SELECTORS.oneTime
//       );

//       if (oneTimeRadio) {

//         var oneTimeText =
//           group.querySelector(
//             '.one_time_purchase_option_app_block span'
//           );

//         if (oneTimeText) {
//           oneTimeText.textContent = 'BUY ONCE';
//         }

//       }

//     });

//   }


//   /* =========================================================
//      SYNC PURCHASE OPTIONS
//      ========================================================= */

//   function updatePurchaseOptions() {

//     var planCards = document.querySelectorAll(
//       SELECTORS.planCard
//     );

//     if (!planCards.length) return;


//     /*
//      * First detect the REAL current checked radio.
//      *
//      * Never use .active for this.
//      */

//     var currentType = detectCurrentPurchaseType();

//     if (currentType) {
//       selectedPurchaseType = currentType;
//     }


//     planCards.forEach(function (planCard) {

//       var groups = planCard.querySelectorAll(
//         SELECTORS.group
//       );

//       if (!groups.length) return;


//       /*
//        * ------------------------------------------------------
//        * IMPORTANT:
//        *
//        * If Shopify rebuilt the purchase UI after changing
//        * variant and nothing is checked, restore the user's
//        * previous purchase type.
//        * ------------------------------------------------------
//        */

//       var checkedRadio = planCard.querySelector(
//         SELECTORS.group +
//         ' ' +
//         SELECTORS.radio +
//         ':checked'
//       );


//       if (!checkedRadio && selectedPurchaseType) {

//         var restoreRadio = getRadioForType(
//           planCard,
//           selectedPurchaseType
//         );

//         if (restoreRadio) {

//           /*
//            * Set property only.
//            *
//            * NO click()
//            * NO dispatchEvent()
//            * NO PointerEvent
//            */

//           restoreRadio.checked = true;

//           checkedRadio = restoreRadio;
//         }

//       }


//       /*
//        * ------------------------------------------------------
//        * If a radio is already selected, update memory.
//        * ------------------------------------------------------
//        */

//       if (checkedRadio) {

//         var type = getPurchaseType(
//           checkedRadio
//         );

//         if (type) {
//           selectedPurchaseType = type;
//         }

//       }


//       /*
//        * ------------------------------------------------------
//        * Update active classes based ONLY on checked radio.
//        * ------------------------------------------------------
//        */

//       updateActiveClasses(planCard);


//       /*
//        * ------------------------------------------------------
//        * Update text.
//        * ------------------------------------------------------
//        */

//       updateTexts(planCard);

//     });

//   }


//   /* =========================================================
//      SAFE UPDATE
//      ========================================================= */

//   function scheduleUpdate(delay) {

//     clearTimeout(updateTimer);

//     updateTimer = setTimeout(function () {

//       updatePurchaseOptions();

//     }, typeof delay === 'number' ? delay : 50);

//   }


//   /* =========================================================
//      RADIO CHANGE
//      ========================================================= */

//   document.addEventListener(
//     'change',
//     function (event) {

//       var target = event.target;

//       if (!target) return;

//       if (
//         target.matches(
//           SELECTORS.planCard +
//           ' ' +
//           SELECTORS.group +
//           ' ' +
//           SELECTORS.radio
//         )
//       ) {

//         /*
//          * User intentionally changed purchase type.
//          * Save it immediately.
//          */

//         var type = getPurchaseType(target);

//         if (type) {
//           selectedPurchaseType = type;
//         }

//         /*
//          * Give the subscription app time to finish
//          * its own change handler.
//          */

//         scheduleUpdate(50);

//         setTimeout(function () {
//           updatePurchaseOptions();
//         }, 200);

//         setTimeout(function () {
//           updatePurchaseOptions();
//         }, 500);

//       }

//     },
//     true
//   );


//   /* =========================================================
//      CLICK
//      ========================================================= */

//   document.addEventListener(
//     'click',
//     function (event) {

//       var target = event.target;

//       if (!target) return;


//       var group = target.closest(
//         SELECTORS.planCard +
//         ' ' +
//         SELECTORS.group
//       );

//       if (!group) return;


//       /*
//        * DO NOT manually click the radio.
//        *
//        * Let the subscription app handle the original
//        * browser click event.
//        */

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 100);

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 300);

//       setTimeout(function () {
//         updatePurchaseOptions();
//       }, 600);

//     },
//     true
//   );


//   /* =========================================================
//      VARIANT CHANGE DETECTION
//      ========================================================= */

//   /*
//    * Shopify/product apps can change variant without
//    * changing the purchase radio immediately.
//    *
//    * We observe DOM changes but NEVER overwrite an existing
//    * checked radio.
//    */

//   function startObserver() {

//     if (!document.body) return;

//     var observer = new MutationObserver(
//       function (mutations) {

//         var relevantChange = false;

//         mutations.forEach(function (mutation) {

//           if (mutation.type === 'childList') {
//             relevantChange = true;
//           }

//           if (
//             mutation.type === 'attributes' &&
//             (
//               mutation.attributeName === 'checked' ||
//               mutation.attributeName === 'class'
//             )
//           ) {
//             relevantChange = true;
//           }

//         });

//         if (!relevantChange) return;

//         clearTimeout(observerTimer);

//         observerTimer = setTimeout(
//           function () {
//             updatePurchaseOptions();
//           },
//           150
//         );

//       }
//     );


//     observer.observe(
//       document.body,
//       {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: [
//           'checked',
//           'class'
//         ]
//       }
//     );

//   }


//   /* =========================================================
//      INITIAL LOAD
//      ========================================================= */

//   function init() {

//     /*
//      * Capture whatever Shopify initially selected.
//      */

//     var initialType =
//       detectCurrentPurchaseType();

//     if (initialType) {
//       selectedPurchaseType = initialType;
//     }


//     updatePurchaseOptions();

//     startObserver();


//     /*
//      * Shopify/subscription app delayed rendering.
//      */

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 100);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 300);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 600);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 1000);

//     setTimeout(function () {
//       updatePurchaseOptions();
//     }, 2000);

//   }


//   /* =========================================================
//      DOM READY
//      ========================================================= */

//   if (document.readyState === 'loading') {

//     document.addEventListener(
//       'DOMContentLoaded',
//       init
//     );

//   } else {

//     init();

//   }


//   /* =========================================================
//      WINDOW LOAD
//      ========================================================= */

//   window.addEventListener(
//     'load',
//     function () {
//       scheduleUpdate(100);
//     }
//   );

// })();

(function () {

  'use strict';

  /* =========================================================
     SETTINGS
  ========================================================= */

  var SELECTORS = {
    parent: '.product-new-pdp',
    planCard: '.plan_card',
    group: '.subscription_group',
    radio: 'input[type="radio"]',
    subscription: 'input[data-radio-type="selling_plan"]',
    oneTime: 'input[data-radio-type="one_time_purchase"]'
  };

  var updateTimer = null;
  var observerTimer = null;

  var selectedPurchaseType = null;

  /*
   * Prevent duplicate console logs
   */
  var lastLoggedPurchaseType = null;


  /* =========================================================
     GET PURCHASE TYPE
  ========================================================= */

  function getPurchaseType(radio) {

    if (!radio) return null;

    var type = radio.getAttribute(
      'data-radio-type'
    );

    if (type === 'selling_plan') {
      return 'subscription';
    }

    if (type === 'one_time_purchase') {
      return 'one_time';
    }

    return null;
  }


  /* =========================================================
     CONSOLE SELECTED PURCHASE TYPE
  ========================================================= */

  function logPurchaseType(type, source) {

    if (!type) return;

    /*
     * Don't console the same state repeatedly
     */

    if (
      lastLoggedPurchaseType === type &&
      source !== 'change'
    ) {
      return;
    }

    lastLoggedPurchaseType = type;

    if (type === 'subscription') {

      console.log(
        '[Purchase Option]',
        'SUBSCRIPTION',
        '| Source:',
        source
      );

    } else if (type === 'one_time') {

      console.log(
        '[Purchase Option]',
        'ONE TIME',
        '| Source:',
        source
      );

    }

  }


  /* =========================================================
     FIND CURRENT SELECTED PURCHASE TYPE
  ========================================================= */

  function detectCurrentPurchaseType() {

    var checkedRadio = document.querySelector(
      SELECTORS.planCard +
      ' ' +
      SELECTORS.group +
      ' ' +
      SELECTORS.radio +
      ':checked'
    );

    if (!checkedRadio) {
      return null;
    }

    return getPurchaseType(
      checkedRadio
    );
  }


  /* =========================================================
     GET RADIO FOR PURCHASE TYPE
  ========================================================= */

  function getRadioForType(
    planCard,
    type
  ) {

    if (!planCard || !type) {
      return null;
    }

    if (type === 'subscription') {

      return planCard.querySelector(
        SELECTORS.group +
        ' ' +
        SELECTORS.subscription
      );

    }

    if (type === 'one_time') {

      return planCard.querySelector(
        SELECTORS.group +
        ' ' +
        SELECTORS.oneTime
      );

    }

    return null;
  }


  /* =========================================================
     UPDATE ACTIVE CLASS
  ========================================================= */

  function updateActiveClasses(
    planCard
  ) {

    var groups =
      planCard.querySelectorAll(
        SELECTORS.group
      );

    groups.forEach(
      function (group) {

        var radio =
          group.querySelector(
            SELECTORS.radio
          );

        if (
          radio &&
          radio.checked
        ) {

          group.classList.add(
            'active'
          );

        } else {

          group.classList.remove(
            'active'
          );

        }

      }
    );

  }


  /* =========================================================
     UPDATE TEXT
  ========================================================= */

  function updateTexts(
    planCard
  ) {

    var groups =
      planCard.querySelectorAll(
        SELECTORS.group
      );

    groups.forEach(
      function (group) {

        /* -----------------------------------------
           SUBSCRIBE & SAVE
        ----------------------------------------- */

        var subscriptionRadio =
          group.querySelector(
            SELECTORS.subscription
          );

        if (subscriptionRadio) {

          var subscriptionLabel =
            subscriptionRadio.closest(
              'label'
            );

          if (subscriptionLabel) {

            var textSpan =
              subscriptionLabel.querySelector(
                '.title_and_price_wrapper > span'
              );

            if (textSpan) {

              textSpan.textContent =
                'SUBSCRIBE & SAVE 10%';

            }

          }

        }


        /* -----------------------------------------
           BUY ONCE
        ----------------------------------------- */

        var oneTimeRadio =
          group.querySelector(
            SELECTORS.oneTime
          );

        if (oneTimeRadio) {

          var oneTimeText =
            group.querySelector(
              '.one_time_purchase_option_app_block span'
            );

          if (oneTimeText) {

            oneTimeText.textContent =
              'BUY ONCE';

          }

        }

      }
    );

  }


  /* =========================================================
     PACK SAVINGS VISIBILITY
  ========================================================= */

  function updatePackSavingsVisibility() {

    var savings =
      document.querySelectorAll(
        '.pack-savings'
      );

    if (!savings.length) {
      return;
    }


    var checkedRadio =
      document.querySelector(
        SELECTORS.planCard +
        ' ' +
        SELECTORS.group +
        ' ' +
        SELECTORS.radio +
        ':checked'
      );

    if (!checkedRadio) {
      return;
    }


    var type =
      checkedRadio.getAttribute(
        'data-radio-type'
      );


    savings.forEach(
      function (element) {

        if ( type ==='one_time_purchase') {
          element.style.display ='none';

          /* add cart button class add */
          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface .price').forEach(function (element) {
              element.classList.remove('compare_price');
          });
          /* end add cart button class add */

          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface [x-text="addToCartText"]').forEach(function (element) {
             element.textContent = 'add to cart';
          });

          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface .sub_price').forEach(function (element) {
             element.classList.add('hidden');
          });

        } else if (
          type ===
          'selling_plan'
        ) {

          element.style.display ='block';

          /* add cart button class add */
          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface .price').forEach(function (element) {
              element.classList.add('compare_price');
          });
          /* end add cart button class add */

          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface [x-text="addToCartText"]').forEach(function (element) {
             element.textContent = 'SUBSCRIBE';
          });

          document.querySelectorAll('.product-new-pdp .add-to-cart-btn .push-btn__surface .sub_price').forEach(function (element) {
             element.classList.remove('hidden');
          });


        }

      }
    );

  }


  /* =========================================================
     SYNC PURCHASE OPTIONS
  ========================================================= */

  function updatePurchaseOptions(
    source
  ) {

    var planCards =
      document.querySelectorAll(
        SELECTORS.planCard
      );

    if (!planCards.length) {
      return;
    }


    /*
     * Detect REAL checked radio
     */

    var currentType =
      detectCurrentPurchaseType();


    /*
     * If Shopify/app has a checked radio,
     * remember it.
     */

    if (currentType) {

      selectedPurchaseType =
        currentType;

    }


    planCards.forEach(
      function (planCard) {

        var groups =
          planCard.querySelectorAll(
            SELECTORS.group
          );

        if (!groups.length) {
          return;
        }


        /*
         * Find checked radio
         */

        var checkedRadio =
          planCard.querySelector(
            SELECTORS.group +
            ' ' +
            SELECTORS.radio +
            ':checked'
          );


        /*
         * IMPORTANT:
         *
         * Only restore previous selection if
         * Shopify completely removed the checked
         * state during DOM rebuild.
         */

        if (
          !checkedRadio &&
          selectedPurchaseType
        ) {

          var restoreRadio =
            getRadioForType(
              planCard,
              selectedPurchaseType
            );

          if (restoreRadio) {

            restoreRadio.checked =
              true;

            checkedRadio =
              restoreRadio;

          }

        }


        /*
         * Remember selected type
         */

        if (checkedRadio) {

          var type =
            getPurchaseType(
              checkedRadio
            );

          if (type) {

            selectedPurchaseType =
              type;

          }

        }


        /*
         * Active classes
         */

        updateActiveClasses(
          planCard
        );


        /*
         * Text
         */

        updateTexts(
          planCard
        );

      }
    );


    /*
     * Pack savings
     */

    updatePackSavingsVisibility();


    /*
     * Console current state ONLY when
     * explicitly requested.
     */

    if (source) {

      var finalType =
        detectCurrentPurchaseType();

      if (finalType) {

        logPurchaseType(
          finalType,
          source
        );

      }

    }

  }


  /* =========================================================
     SAFE UPDATE
  ========================================================= */

  function scheduleUpdate(
    delay,
    source
  ) {

    clearTimeout(
      updateTimer
    );

    updateTimer =
      setTimeout(
        function () {

          updatePurchaseOptions(
            source
          );

        },
        typeof delay === 'number'
          ? delay
          : 50
      );

  }


  /* =========================================================
     RADIO CHANGE
  ========================================================= */

  document.addEventListener(
    'change',
    function (event) {

      var target =
        event.target;

      if (!target) {
        return;
      }


      if (
        target.matches(
          SELECTORS.planCard +
          ' ' +
          SELECTORS.group +
          ' ' +
          SELECTORS.radio
        )
      ) {

        /*
         * User changed purchase option.
         */

        var type =
          getPurchaseType(
            target
          );


        if (type) {

          selectedPurchaseType =
            type;


          /*
           * Immediately console user selection.
           */

          logPurchaseType(
            type,
            'change'
          );

        }


        /*
         * Update savings
         */

        updatePackSavingsVisibility();


        /*
         * Let subscription app finish
         * its own handler first.
         */

        scheduleUpdate(
          50,
          'change'
        );


        setTimeout(
          function () {

            updatePurchaseOptions(
              'change'
            );

          },
          200
        );


        setTimeout(
          function () {

            updatePurchaseOptions();

          },
          500
        );

      }

    },
    true
  );


  /* =========================================================
     CLICK
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;

      if (!target) {
        return;
      }


      var group =
        target.closest(
          SELECTORS.planCard +
          ' ' +
          SELECTORS.group
        );

      if (!group) {
        return;
      }


      /*
       * Don't manually click radio.
       */

      setTimeout(
        function () {

          updatePurchaseOptions();

        },
        100
      );


      setTimeout(
        function () {

          updatePurchaseOptions();

        },
        300
      );


      setTimeout(
        function () {

          updatePurchaseOptions();

        },
        600
      );

    },
    true
  );


  /* =========================================================
     VARIANT / DOM CHANGE DETECTION
  ========================================================= */

  function startObserver() {

    if (!document.body) {
      return;
    }


    var observer =
      new MutationObserver(
        function (mutations) {

          var relevantChange =
            false;


          mutations.forEach(
            function (mutation) {

              if (
                mutation.type ===
                'childList'
              ) {

                relevantChange =
                  true;

              }


              if (
                mutation.type ===
                'attributes' &&
                (
                  mutation.attributeName ===
                  'checked' ||
                  mutation.attributeName ===
                  'class'
                )
              ) {

                relevantChange =
                  true;

              }

            }
          );


          if (!relevantChange) {
            return;
          }


          clearTimeout(
            observerTimer
          );


          observerTimer =
            setTimeout(
              function () {

                updatePurchaseOptions();

              },
              150
            );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'checked',
          'class'
        ]
      }
    );

  }


  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  function init() {

    /*
     * Capture Shopify's initial selection.
     */

    var initialType =
      detectCurrentPurchaseType();


    if (initialType) {

      selectedPurchaseType =
        initialType;


      /*
       * Console ON LOAD selection
       */

      logPurchaseType(
        initialType,
        'page load'
      );

    }


    /*
     * Initial update
     */

    updatePurchaseOptions();


    /*
     * Start observer
     */

    startObserver();


    /*
     * Delayed Shopify rendering
     */

    setTimeout(
      function () {
        updatePurchaseOptions();
      },
      100
    );


    setTimeout(
      function () {
        updatePurchaseOptions();
      },
      300
    );


    setTimeout(
      function () {
        updatePurchaseOptions();
      },
      600
    );


    setTimeout(
      function () {
        updatePurchaseOptions();
      },
      1000
    );


    setTimeout(
      function () {
        updatePurchaseOptions();
      },
      2000
    );

  }


  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /* =========================================================
     WINDOW LOAD
  ========================================================= */

  window.addEventListener(
    'load',
    function () {

      scheduleUpdate(
        100
      );

    }
  );

})();